/*
    Copyright 2020 Lauren Gyldenlove.
    This file is part of Duelmaster.

    Duelmaster is free software: you can redistribute it and/or modify
    it under the terms of the GNU General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    Duelmaster is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU General Public License for more details.

    You should have received a copy of the GNU General Public License
    along with Foobar.  If not, see <https://www.gnu.org/licenses/>.
 */

import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { SvgIcon, Theme } from '@material-ui/core';
import { mdiStar } from '@mdi/js';

const useStyle = makeStyles((theme: Theme) => {
    return {
        winningStar: {
            color: "#FF0"
        },
        emptyStar: {
            color: "#330"
        }
    };
});

export interface StarProps {
    win: boolean
}

export const Star = (props: StarProps) => {
    const classes = useStyle();
    return (
        <SvgIcon className={props.win ? classes.winningStar : classes.emptyStar}>
            <path d={mdiStar} />
        </SvgIcon>
    )
}

